// Icons the approved design uses that the installed Tabler set (3.35) does not ship. Paths
// are exported from the Figma file; colour follows `currentColor`.

/** Tabler "sparkles-2": the Ad Generation with AI tile and buttons. */
export function IconSparklesTwo({ size = 24, stroke = 2, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M14.516 6.454C14.0274 6.67952 13.5202 6.8622 13 7C13.5207 7.13663 14.028 7.3197 14.516 7.547C15.427 7.985 16.01 8.561 16.453 9.479C16.66 9.905 16.835 10.406 17 11C17.1363 10.4776 17.3194 9.96857 17.547 9.479C17.99 8.562 18.573 7.985 19.484 7.547C19.9726 7.32114 20.4798 7.13812 21 7C20.409 6.834 19.91 6.659 19.484 6.454C18.573 6.016 17.99 5.439 17.547 4.521C17.34 4.095 17.165 3.595 17 3C16.835 3.594 16.66 4.094 16.453 4.522C16.01 5.439 15.427 6.016 14.516 6.454Z"
        stroke="currentColor"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.652 13.468C4.1089 13.668 3.55776 13.8455 3 14C3.55776 14.1545 4.1089 14.332 4.652 14.532C7.193 15.485 8.505 16.77 9.468 19.338C9.66943 19.884 9.84693 20.4385 10 21C10.1531 20.4385 10.3306 19.884 10.532 19.338C11.494 16.77 12.806 15.485 15.348 14.532C15.8911 14.332 16.4422 14.1545 17 14C16.3987 13.832 15.848 13.6547 15.348 13.468C12.807 12.515 11.495 11.229 10.532 8.662C10.3306 8.116 10.1531 7.56148 10 7C9.84693 7.56148 9.66943 8.116 9.468 8.662C8.505 11.23 7.194 12.515 4.652 13.468Z"
        stroke="currentColor"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/** The three-star mark of the assistant's welcome state. */
export function IconSparklesTrio({ size = 42, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 42 42" fill="none" aria-hidden="true" {...props}>
      {[
        'M30.4749 32.5251C29.8185 31.8687 28.9283 31.5 28 31.5C28.9283 31.5 29.8185 31.1313 30.4749 30.4749C31.1313 29.8185 31.5 28.9283 31.5 28C31.5 28.9283 31.8687 29.8185 32.5251 30.4749C33.1815 31.1313 34.0717 31.5 35 31.5C34.0717 31.5 33.1815 31.8687 32.5251 32.5251C31.8687 33.1815 31.5 34.0717 31.5 35C31.5 34.0717 31.1313 33.1815 30.4749 32.5251Z',
        'M30.4749 11.5251C29.8185 10.8687 28.9283 10.5 28 10.5C28.9283 10.5 29.8185 10.1313 30.4749 9.47487C31.1313 8.8185 31.5 7.92826 31.5 7C31.5 7.92826 31.8687 8.8185 32.5251 9.47487C33.1815 10.1313 34.0717 10.5 35 10.5C34.0717 10.5 33.1815 10.8687 32.5251 11.5251C31.8687 12.1815 31.5 13.0717 31.5 14C31.5 13.0717 31.1313 12.1815 30.4749 11.5251Z',
        'M18.8254 24.0754C16.8562 26.0445 15.75 28.7152 15.75 31.5C15.75 28.7152 14.6438 26.0445 12.6746 24.0754C10.7055 22.1062 8.03477 21 5.25 21C8.03477 21 10.7055 19.8938 12.6746 17.9246C14.6438 15.9555 15.75 13.2848 15.75 10.5C15.75 13.2848 16.8562 15.9555 18.8254 17.9246C20.7945 19.8938 23.4652 21 26.25 21C23.4652 21 20.7945 22.1062 18.8254 24.0754Z',
      ].map((d) => (
        <path key={d.slice(0, 12)} d={d} stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
      ))}
    </svg>
  )
}
